import { useEffect, useState } from 'react';
import { SHA256, enc } from 'crypto-js';
import { useLDClient, useFlags as useLDFlags } from 'launchdarkly-react-client-sdk';
import { getLogin } from 'utils/API';

export const FLAGS = {
  duskbreakersSurvey: 'survey-announcement',
  siteHierarchy: 'site-hierarchy',
  hatchening: 'hatchening',
  preHatchening: 'pre-hatchening',
  newGallery: 'new-gallery',
  omnigrowUpdatePopup: 'omnigrow-update-popup',
} as const;

export type FlagKey = keyof typeof FLAGS;
export type Flag = typeof FLAGS[FlagKey];

export const getLoggedInLDUser = () => {
  const login = getLogin();
  return getLDUser(login?.userId);
};

const getLDUser = (userId = crypto.randomUUID()) => {
  return {
    key: SHA256(userId).toString(enc.Base64),
  };
};

export const useFlags = () => {
  const client = useLDClient();
  const flags = useLDFlags();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (Object.keys(flags).length > 0) {
      setIsReady(true);
    }
  }, [flags]);

  const isFlagEnabled = (flag: Flag) => {
    return flags[flag] === true;
  };

  const identifyUser = () => {
    client?.identify(getLoggedInLDUser());
  };

  return {
    isFlagEnabled,
    identifyUser,
    isReady,
  };
};
